import { ContactUs } from '@/components/screens';
import { GetStaticProps, NextPage } from 'next';

const ContactUsPage: NextPage = () => {
	return <ContactUs />;
};

export const getStaticProps: GetStaticProps = async () => {
	return { props: {} };
};

export default ContactUsPage;
